import Vue from "vue";
import Vuex from "vuex";
import baseAPI from "@/http";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    isOutros: false,
    isAdmin: false,
    loading: false,
    token: null,
    user: {},
    banner: null,
    usuario: {},
    card: null,
    produto: null,
    demanda: null,
    tutorialCache: false
  },
  mutations: {
    SET_DEMANDA(store, demanda) {
      store.demanda = demanda;
    },
    SET_PRODUTO(store, produto) {
      store.produto = produto;
    },
    SET_CARD(store, card) {
      store.card = card;
    },
    SET_USUARIO(store, usuario) {
      store.usuario = usuario;
    },
    SET_BANNER(store, banner) {
      store.banner = banner;
    },

    SET_USER(state, payload) {
      state.user = payload;
      state.isAuthenticated = true;
      localStorage.setItem("user", payload);
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_TOKEN(state, payload) {
      state.token = payload;
      state.isAuthenticated = true;
      localStorage.setItem("token", payload);
    },
    LOGOUT: state => {
      state.isAuthenticated = false;
      state.isAdmin = false;
      delete state.token;
      localStorage.removeItem("token");

      delete state.user;
      localStorage.removeItem("user");

      delete baseAPI.defaults.headers.Authorization;
      window.location.reload();
    },
    SET_ADMIN(state, payload) {
      state.isAdmin = payload;
    },
    SET_OUTROS(state, payload) {
      state.isOutros = payload;
    }
    ,
    SET_OUTROS(state, payload) {
      state.isOutros = payload;
    }
  },
  actions: {
    setLoading({ commit }, payload) {
      commit("SET_LOADING", payload);
    },
    setTutorialCache() {
      localStorage.setItem('tutorial', true)
    },
    setToken({ commit }, payload) {
      commit("SET_TOKEN", payload);
    },
    setUser({ commit }, payload) {
      commit("SET_USER", payload);
    },
    setAdmin({ commit }, payload) {
      commit("SET_ADMIN", payload);
    },
    logout({ commit }) {
      commit("LOGOUT");
    },
    setOutros({ commit }, payload) {
      commit("SET_OUTROS", payload);
    }
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    isAdmin: state => state.isAdmin,
    loading: state => state.loading,
    token: state => state.token,
    user: state => JSON.parse(JSON.stringify(state.user)),
    isOutros: state => state.isOutros,
    banner: state => state.banner,
    card: state => state.card,
    tutorialCache: state => localStorage.getItem('tutorial')
  }
});
